import EscalationSettingsComponent from '@/components/bot/EscalationSettings'
import BotSettingsNavTabs from '@/components/bot/BotSettingsNavTabs'
import { Headphones } from 'lucide-react'

export default function EscalationSettingsPage() {
  return (
    <div className="p-4 sm:p-6 overflow-x-hidden min-h-screen bg-slate-50">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#075E54]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <Headphones className="w-5 h-5 text-[#075E54]" />
          </div>
          <div>
            <h1 data-tour="escalation-main" className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">Derivación a Atención Humana</h1>
            <p className="text-xs sm:text-sm text-gray-600">
              Personaliza cómo el asistente transfiere una conversación a tu equipo de ventas o soporte cuando un cliente necesita ayuda especializada.
            </p>
          </div>
        </div>
      </div>

      <BotSettingsNavTabs />

      <div data-tour="escalation-rules" className="bg-white rounded-2xl border border-slate-200/80 shadow-sm">
        <EscalationSettingsComponent />
      </div>
    </div>
  )
}
